import Plyr from 'plyr';

const youtubeOptions = {
    captions: {
        active: false,
    },
    youtube: {
        cc_load_policy: 0,
    },
};

const updateYoutubeCaptionModules = (player, enabled) => {
    const method = enabled ? 'loadModule' : 'unloadModule';

    ['captions', 'cc'].forEach((module) => {
        try {
            player.embed?.[method]?.(module);
        } catch {
            // YouTube does not document this API, so it may be unavailable.
        }
    });
};

const setYoutubeCaptions = (player, enabled) => {
    const captionsButton = player.elements.buttons.captions;

    player.captions.active = enabled;
    player.captions.toggled = enabled;

    if (captionsButton) {
        captionsButton.pressed = enabled;
    }

    player.elements.container.classList.toggle(player.config.classNames.captions.active, enabled);
    player.storage.set({ captions: enabled });

    updateYoutubeCaptionModules(player, enabled);
};

const setupYoutubeCaptions = (player) => {
    player.toggleCaptions = (enabled) => {
        const nextState = typeof enabled === 'boolean' ? enabled : !player.captions.toggled;

        setYoutubeCaptions(player, nextState);
    };

    player.on('ready', () => {
        player.elements.container.classList.add(player.config.classNames.captions.enabled);
        player.toggleCaptions(false);
    });

    const syncCaptions = () => {
        updateYoutubeCaptionModules(player, Boolean(player.captions.toggled));
    };

    ['play', 'playing', 'pause', 'waiting', 'seeked'].forEach((event) => {
        player.on(event, syncCaptions);
    });
};

const plyr = {
    playerInstances: [],
    create(player) {
        const isYoutube = player.dataset.plyrProvider === 'youtube';
        const options = isYoutube ? youtubeOptions : undefined;
        const instance = new Plyr(player, options);

        if (isYoutube) {
            setupYoutubeCaptions(instance);
        }

        this.playerInstances.push(instance);

        return instance;
    },
    init() {
        const players = document.querySelectorAll('.js-player');
        players.forEach((player) => {
            this.create(player);
        });

        return this.playerInstances;
    }
};

export default plyr;
